import { SearchDocumentsFields } from 'documents/dtos/document'

/**
 * Unique identifiers for each column.
 */
export enum ColumnId {
  Checkbox = 'checkbox',
  DocumentTitle = 'documentTitle',
  Workspace = 'workspace',
  Owner = 'owner',
  Type = 'type',
  DateModified = 'dateModified',
  FileSize = 'fileSize',
  LinkedJob = 'linkedJob',
  Action = 'action',
}

export interface StaticColumnDetails {
  id: ColumnId
  header: string
  sortable: boolean
  field?: SearchDocumentsFields
}

/**
 * Static column details for populating the Document Management table.
 */
export const DocumentsTableColumns: StaticColumnDetails[] = [
  {
    id: ColumnId.Checkbox,
    header: '',
    sortable: false,
  },
  {
    id: ColumnId.DocumentTitle,
    header: 'Name',
    sortable: true,
    field: SearchDocumentsFields.Title,
  },
  {
    id: ColumnId.Workspace,
    header: 'Workspace',
    sortable: false,
  },
  // {
  //   id: ColumnId.Owner,
  //   header: 'Uploaded by',
  //   sortable: false,
  // },
  {
    id: ColumnId.Type,
    header: 'Type',
    sortable: false,
  },
  {
    id: ColumnId.DateModified,
    header: 'Modified',
    sortable: true,
    field: SearchDocumentsFields.DateModified,
  },
  // {
  //   id: ColumnId.FileSize,
  //   header: 'File size',
  //   sortable: false,
  // },
  {
    id: ColumnId.LinkedJob,
    header: 'Linked to',
    sortable: false,
  },
  {
    id: ColumnId.Action,
    header: '',
    sortable: false,
  },
]
